import React from 'react';
import { MdContactPage } from 'react-icons/md';
import { FaUserAlt } from 'react-icons/fa';
import { truncate } from '../../formatters';

import PropTypes from 'prop-types';
import { useTooltip } from '../../hooks';
import BaseTooltip from './BaseTooltip';

const propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}


const NodeTooltip = ({ width, height }) => {
  const { currentNode: data, mosuePosition: { top, left } } = useTooltip();

  if (!data) return null;

  const completedImpressionsPC = (data.completedImpressions / data.total) * 100;
  const profileHeight = 80;
  const titleWidth = Math.max(140, width - 40);

  return (
    <BaseTooltip width={width} height={data.page ? height : profileHeight}>
      <g transform={`translate(${left} ${top + 13})`}>
        {data.page !== null ?
          <MdContactPage x={10} size={15} style={{ fill: data.color }} /> :
          <FaUserAlt x={10} y={2} size={10} style={{ fill: data.color }} />}
        <text x={30} y={12} fontWeight="bold">
          {truncate(`#${data.page !== null ? data.page : data.profile} - ${data.name}`, titleWidth)}
        </text>
      </g>
      <g transform={`translate(${left} ${top + 40})`}>
        <text>
          <tspan x={10} y={10}>
            Impressions: {data.total}
          </tspan>
          {
            !!data.page && (
              <>
                <tspan x={10} y={30}>
                  Slot: {data.slot}
                </tspan>
                <tspan x={10} y={50}>
                  Completed: {data.completedImpressions}
                </tspan>
                <tspan x={10} y={70}>
                  Completed Percent: {completedImpressionsPC !== 0 ? `${completedImpressionsPC.toFixed()}%` : 'N/A'}
                </tspan>
              </>
            )
          }
        </text>
      </g>
    </BaseTooltip >
  )
}

NodeTooltip.propTypes = propTypes
NodeTooltip.defaultProps = {}


export default NodeTooltip;